export default __webpack_public_path__ + "static/media/img-7.64f2ad20.jpg";